import { ROUTES } from '@shared/utils';
import { browse, discover, favourites, offers } from '../../tabs/tabs';
import type { ProductNavigationConfig, SectionMatcher } from '../../types';

const { DISCOVERY, FAVOURITES, BROWSE, OFFERS } = ROUTES.CASINO;

const casinoNavigation: ProductNavigationConfig = {
  navigationTabs: [
    { ...discover, href: DISCOVERY },
    { ...browse, href: BROWSE },
    { ...favourites, href: FAVOURITES },
    { ...offers, href: OFFERS },
  ],
  sectionMatchers: [
    [`^${FAVOURITES}(/.*)?$`, 'favourites'],
    [`^${OFFERS}(/.*)?$`, 'offers'],
    [`^${DISCOVERY}/.*$`, 'browse'],
    [`^${DISCOVERY}`, 'discover'],
  ] as const satisfies SectionMatcher[],
  staticNavOnPages: [FAVOURITES, OFFERS],
};

export { casinoNavigation };
